module.exports = __webpack_public_path__ + "static/media/sheet-music.7e0e6ff9.jpg";